var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice_operation_page"},[_c('a',{staticClass:"margin_r",attrs:{"href":_vm.pdfPath,"target":"_blank"}},[_vm._v("PDF")]),_c('a',{attrs:{"href":_vm.csvPath,"target":"_blank"}},[_vm._v("CSV")])])}
var staticRenderFns = []

export { render, staticRenderFns }